
import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '@/views/Home3'

import MenuUsuario from '@/components/plantilla/MenuUsuario.vue';

import MenuStorePrincipal from '@/components/plantilla/MenuStorePrincipal.vue';

import MenuAdmin from '@/components/plantilla/MenuAdmin';

import MenuPerfil from '@/components/plantilla/MenuPerfil';


import MenuHome from '@/components/plantilla/MenuHome';



Vue.use(VueRouter)

const routes = [ 

  {
  path: '/',
  component: MenuStorePrincipal,
  children: [
    {
      path: '',
      redirect: 'store/all'
    },
    {
      path: 'store/:identificador',
      name: 'homeTiendaAll',
      component: () => import('../views/tienda/HomeTiendaAll.vue'),
      props: true
    }
  ]
},


  
  {
    path: '/linkstec',
    component: MenuHome,
    children: [
      {
        path: '/',
       name: 'linkstec',
       component: () => import(/* webpackChunkName: "blog" */ '../views/Home3.vue')
      }
      
      ,
      {
        path: '/prueba',
        name: 'prueba',
        component: () => import(/* webpackChunkName: "blog" */ '../components/prueba/PruebaCa.vue')
      },
      {
        path: '/perfiles',
        name: 'perfiles',
        component: () => import(/* webpackChunkName: "blog" */ '../components/perfiles/PerfilesView.vue')
      },
      {
        path: '/register_public',
        name: 'register_public',
        component: () => import(/* webpackChunkName: "usuario" */ '../views/UsuarioRegisterV.vue')
        },
    
  
  
  ]
  },

  {
    path: '/',
    name:'perfil',
    component: MenuPerfil,
    children: [
      {
        path: 'perfil/:identificador',
        name: 'perfil_hijo',
        component: () => import(/* webpackChunkName: "blog" */ '../views/PerfilV.vue')
      },
      {
        path: '/api/password/reset',
        name: 'pass_change',
        component: () => import(/* webpackChunkName: "blog" */ '../views/PassChangeV.vue'),
        // Para que los parámetros de la query sean parte de las props del componente
    //  props: (route) => ({ email: route.query.email, signature: route.query.signature, expires: route.query.expires }),
      },
      {
        path: '/api/email/verify',
        name: 'email_verify',
        component: () => import(/* webpackChunkName: "blog" */ '../views/EmailVerifyV.vue'),
      },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "blog" */ '../views/LoginView.vue')
    }
  ]
  },

  

  {
    path: '/',
    component: MenuAdmin,
    children: [
      {
      path: '/data_empresa',
      name: 'data_empresa',
      component: () => import(/* webpackChunkName: "empresa" */ '../views/EmpresaDataV.vue')
      }
      ,
      {
      path: '/vendedor',
      name: 'vendedor',
      component: () => import(/* webpackChunkName: "categoria" */ '../views/tienda/VendedorV.vue')
      } ,

 ,
      {
      path: '/categoria',
      name: 'categoria',
      component: () => import(/* webpackChunkName: "categoria" */ '../views/tienda/CategoriaV.vue')
      },


      {
      path: '/proveedor',
      name: 'proveedor',
      component: () => import(/* webpackChunkName: "proveedor" */ '../views/tienda/ProveedorV.vue')
      } ,
      {
      path: '/producto',
      name: 'producto',
      component: () => import(/* webpackChunkName: "producto" */ '../views/tienda/ProductoV.vue')
      } ,
        {
          path: '/imagenes_base',
             name: 'imagenesbase',
           component: () => import(/* webpackChunkName: "imagenesbase" */ '../views/ImagenesBaseV.vue')
        },
        {
          path: '/logout',
          name: 'logout',
          component: () => import(/* webpackChunkName: "blog" */ '../views/Logout.vue')
        },
        {
          path: '/principal',
          name: 'principal',
          component: () => import(/* webpackChunkName: "principal" */ '../views/PrincipalV.vue')
          },  {
            path: '/opcion',
            name: 'opcion',
            component: () => import(/* webpackChunkName: "opcion" */ '../views/OpcionV.vue')
            }


    ]
},

{
  path: '/',
  component: MenuUsuario,
  children: [


      {
      path: '/register_producto_user',
      name: 'register_producto_user',
      component: () => import(/* webpackChunkName: "producto" */ '../views/tienda/RegisterProductoUsuarioV.vue')
      } ,

    {
      path: '/data_user',
      name: 'data_user',
      component: () => import(/* webpackChunkName: "usuario" */ '../views/UsuarioDataV.vue')
      }
      ,
    
    {
      path: '/registro_comprobantes',
      name: 'registro_comprobantes',
      component: () => import(/* webpackChunkName: "empresa" */ '../views/RegistroComprobantesV.vue')
      }
      ,
    {
      path: '/registro_compra',
      name: 'registro_compra',
      component: () => import(/* webpackChunkName: "empresa" */ '../components/economy/RegistroCompra.vue')
      }
      ,
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "usuario" */ '../views/UsuarioRegisterV.vue')
      },
      {
        path: '/perfil/:identificador/add/',
        name: 'add',
        component: () => import(/* webpackChunkName: "usuario" */ '../views/PrincipalRegisterV.vue')
        },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
      path: '/pruebaimg',
      name: 'pruebaimg',
      component: () => import(/* webpackChunkName: "about" */ '../components/prueba/PruebaImg.vue')
    },
    {
      path: '/pruebamapa',
      name: 'pruebamapa',
      component: () => import(/* webpackChunkName: "about" */ '../components/prueba/MapaMundial.vue')
    }
    
    ,// {
     // path: '/logout',
     // name: 'logout',
     // component: () => import(/* webpackChunkName: "blog" */ '../views/Logout.vue')
    //}
    
    , 
  //	{
   //   path: '/imagenes_base',
   //   name: 'imagenesbase',
   //   component: () => import(/* webpackChunkName: "imagenesbase" */ '../views/ImagenesBaseV.vue')
    //	}*/
      ,
 //   {
   //   path: '/prueba',
  //    name: 'prueba',
  //    component: () => import(/* webpackChunkName: "blog" */ '../views/PruebaV.vue')
  //  }
      
  ]
},



//{
  //  path: '/',
  //  name: 'store',
  //  component: MenuStorePrincipal,
 //   children: [
     
 //     {
    //    path: '/store/:identificador',
   //     name: 'homeTiendaAll',
   //     component: () => import(/* webpackChunkName: "blog" */ '../views/tienda/HomeTiendaAll.vue'),
   //     props: true
   //   }     
    
    
//  ]
//  }




	

] 

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

